import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ErrorMessage from "./../../atoms/ErrorMessage";
import MealItem from "./../../molecules/MealItem";
import MenuPageSkeletonLoader from "./../../molecules/MenuPageSkeleton";

import styled from "styled-components";

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: ${(props) => props.theme.sizes.maxWidth};
  margin: 0 auto;
  margin-top: 20px;
  padding-top: 22px;
  padding-bottom: 100px;

  &.reverse {
    flex-direction: column-reverse;
  }

  @media (min-width: 990px) {
    padding-bottom: 80px;
  }

  > div {
    margin-bottom: 25px;
  }
`;

const SectionWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin-top: 40px;

  @media (min-width: 1280px) {
    .meal-item {
      width: 25%;

      &:nth-child(3n + 4)::before {
        display: none;
      }

      &:nth-child(4n + 5)::before {
        display: block;
        content: "";
        position: absolute;
        width: calc(100% - 15px);
        border-top: 1px solid #e6e6e6;
        transform: translate(0, -10px);
      }
    }
  }
`;

function Menu(props) {
  const { mealConstructorCollections } = props;
  const [errorMessage, setErrorMessage] = useState("");
  const [meals, setMeals] = useState([]);

  const getDietTypeFromUrl = () => {
    const path = window.location.pathname.toLowerCase();
    
    if (path.includes('diabetic-friendly') || path.includes('diabetes')) {
      return 'Diabetes Plan';
    } else if (path.includes('lowfodmap') || path.includes('low-fodmap')) {
      return 'Low-FODMAP Plan';
    } else if (path.includes('gluten-free')) {
      return 'Gluten-Free Plan';
    } else if (path.includes('heart-friendly')) {
      return 'Heart-Friendly Plan';
    } else if (path.includes('carb-conscious')) {
      return 'Carb-Conscious Plan';
    } else if (path.includes('mediterranean')) {
      return 'Mediterranean Plan';
    } else if (path.includes('glp-1')) {
      return 'GLP-1 Plan';
    }
    
    return 'Low-FODMAP Plan';
  };

  function filterOutSmoothies(data) {
    return data.filter((item) => !item.tags.includes("Smoothie"));
  }

  const cleanImageUrl = (url) => {
    if (!url) return '';
    // Тільки додаємо https: якщо потрібно
    return url.startsWith('//') ? `https:${url}` : url;
  };

  useEffect(() => {    
    if (!mealConstructorCollections) {
      console.warn('[Menu] No mealConstructorCollections provided');
      return;
    }

    try {
      const currentDietType = getDietTypeFromUrl();
      
      const allMeals = [];
      
      Object.values(mealConstructorCollections).forEach(collection => {
        if (collection.products && Array.isArray(collection.products)) {
          allMeals.push(...collection.products);
        }
      });

      const filteredByDiet = allMeals.filter(meal => meal.dietType === currentDietType);

      const filteredMeals = filterOutSmoothies(filteredByDiet);
      
      setMeals(filteredMeals);
    } catch (error) {
      console.error('[Menu] Error processing collections:', error);
      setErrorMessage('Error loading meals');
    }
  }, [mealConstructorCollections]);

  return (
    <Wrap>
      {errorMessage && <ErrorMessage modalIsOpen={errorMessage.length ? true : false} message={errorMessage} />}

      <SectionWrap>
        {meals.length > 0 &&
          meals.map((meal) => {
            return (
              <MealItem
                id={meal.id}
                excluded={false}
                hidden={false}
                title={meal.title}
                image={cleanImageUrl(meal.image)}
                tags={meal.tags}
                key={meal.id}
                variants={meal.variants}
                mealChange={null}
                images={meal.images.map(img => cleanImageUrl(img))}
                handle={meal.handle}
                mealBoughtQuantity={0}
                stockCapacity={999}
                quantitySelected={0}
                frequence={"recurring"}
                view={"standart"}
                deliveryItem={true}
                charge={null}
                linkToCollection={null}
                mealsCollectionButtonLabel="View Meal"
              />
            );
          })}
      </SectionWrap>
      {meals.length === 0 && <MenuPageSkeletonLoader />}
    </Wrap>
  );
}

Menu.propTypes = {
  mealConstructorCollections: PropTypes.object,
};

export default Menu; 